import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import type { PontoTempoMedioConclusao } from '../solicitacoesDashboard.utils';

interface TempoMedioConclusaoChartProps {
  dados: PontoTempoMedioConclusao[];
}

export default function TempoMedioConclusaoChart({ dados }: TempoMedioConclusaoChartProps) {
  if (dados.length === 0) {
    return (
      <div className="rounded-lg border border-gray-200 bg-white p-6">
        <h3 className="mb-2 font-montserrat text-base font-semibold text-gray-900">Tempo Médio de Conclusão</h3>
        <p className="text-sm text-gray-400">Ainda não há Solicitações Concluídas com data de abertura e conclusão.</p>
      </div>
    );
  }

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-6">
      <h3 className="mb-4 font-montserrat text-base font-semibold text-gray-900">Tempo Médio de Conclusão (dias)</h3>
      <ResponsiveContainer width="100%" height={Math.max(220, dados.length * 36)}>
        <BarChart data={dados} layout="vertical" margin={{ left: 24 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis type="number" style={{ fontSize: '12px', fontFamily: 'Montserrat' }} stroke="#6b7280" />
          <YAxis
            type="category"
            dataKey="label"
            width={160}
            style={{ fontSize: '12px', fontFamily: 'Montserrat' }}
            stroke="#6b7280"
          />
          <Tooltip
            contentStyle={{ borderRadius: '8px', border: '1px solid #e5e7eb', fontFamily: 'Montserrat' }}
            formatter={(valor: number, _nome, item) => [
              `${valor} dias (${item.payload.quantidade} concluída${item.payload.quantidade === 1 ? '' : 's'})`,
              'Média',
            ]}
          />
          <Bar dataKey="mediaDias" fill="#0EA5E9" radius={[0, 6, 6, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
